<h2 class="text-center">Quiz Envelops</h2>
<div class="table-responsive-sm-12" *ngIf="(quizEnvelops.length>0) && !loading">
  <table datatable  [dtOptions]="dtOptions" class="table table-striped display compact" id="myDataTable">
    <thead>
    <tr>
        <th>Id</th>
        <th>Qid</th>
        <th>Subscription Id</th>
        <th>Date Created</th>

        <th>Subject Name</th>
        <th>Questions</th>
        <th>Student</th>
        <th>Is Completed</th>
    </tr>
    </thead>

    <tbody>

        <tr *ngFor="let quizEnvelop of quizEnvelops;">
        <td>
            <a [routerLink]="['/admin/envelop/quiz',quizEnvelop.server_quiz_envelop_id]">{{quizEnvelop.server_quiz_envelop_id}}</a>
        </td>
        <td>{{quizEnvelop['server_quiz_id']}}</td>
        <td class="text-center">{{quizEnvelop.server_subscription_id}}</td>
        <td class="text-center">{{quizEnvelop.datecreated}}</td>

        <td class="text-center">{{quizEnvelop.subjectName}}</td>

        <td class="text-center">
            <a [routerLink]="['/admin/envelop/quiz',quizEnvelop.server_quiz_envelop_id]">
                {{ quizEnvelop.question_count}}
            </a>
        </td>
        <td class="text-center">{{quizEnvelop.studentNames}}</td>
        <td class="text-center">{{quizEnvelop.isCompleted}}</td>
    </tr>

    </tbody>

</table>
</div>
<app-empty [isEmpty]="isEmpty"></app-empty>
<app-loading [loading]="loading"></app-loading>
